import api from '@/utils/http'

/**
 功能：登录
 time: 2025-13-01 17:13:44
 **/
export function login(data) {
    return api.post('/partner/login/ajaxLogin', data)
}

/**
 功能：退出
 time: 2025-13-01 17:13:47
 **/
export function logout() {
    return api.get('/partner/login/ajaxLogout')
}
/**
 * 功能：
 * @author Mr Wang
 * @date 2026/3/9 21:42
 */
export function getHomeStatic() {
    return api.get('/partner/index/getHomeStatic')
}
/**
 * 功能：
 * @author Mr Wang
 * @date 2026/3/9 22:15
 */
export function getHomeStaticLine() {
    return api.get('/partner/index/getHomeStaticLine')
}
/**
 * 功能：
 * @author Mr Wang
 * @date 2026/3/9 22:45
 */
export function getHomeExpendBar() {
    return api.get('/partner/index/getHomeExpendBar')
}
/**
 * 功能：
 * @author Mr Wang
 * @date 2026/3/9 22:55
 */
export function getHomeExpenseBar() {
    return api.get('/partner/index/getHomeExpenseBar')
}